import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Panel, Button, Col, Row, HelpBlock } from 'react-bootstrap';
import { FormActions, Select } from '../../../common/components/formControls';
import CentersDropdownList from '../../centers/DropdownList';
import { withTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

const Filter = ({ handleSubmit, submitting, t, years }) => {
	return (
		<Panel header={t('Common_Filter')}>
			<Panel.Heading><FontAwesomeIcon icon={faFilter} />{t('Common_Filter')}</Panel.Heading>
			<Panel.Body>
				<form onSubmit={handleSubmit}>
					<Row>
						<Col sm={8}>
							<CentersDropdownList render='field' name='centerId' filter={center => !center.isKindergarten} label={t('FinancialReport_Center')} />
						</Col>
						<Col sm={4}>
							<Select name='year' data={years} hideEmptyOption={true} label={t('FinancialReport_Year')} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={submitting} bsStyle='warning'>{t('Common_ExportToExcel')}</Button>
					</FormActions>
					<HelpBlock>{t('Common_ExportHelpText')}</HelpBlock>
				</form>
			</Panel.Body>
		</Panel>
	);
};

Filter.propTypes = {
	onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'financialReportFilter' })(withTranslation()(Filter));